module.exports = __webpack_public_path__ + "static/media/Group9262.3fee9a92.png";